import { FASTElement as e, html as a } from "@microsoft/fast-element";
import { tableStyles as r } from "./table.styles.js";
import { TableMixin as s } from "./table-mixin.js";
import { applyMixins as l } from "../common/apply-mixins.js";
const i = class i extends e {
  connectedCallback() {
    super.connectedCallback(), this.variant || (this.variant = "zebra");
  }
};
i.definition = {
  name: "table",
  template: () => a` <slot></slot>`,
  styles: r,
  attributes: ["variant"]
};
let t = i;
l(t, s);
export {
  t as Table
};
